import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const helpTextDefaultVariants = {}
const helpTextCompoundVariants = []

const helpTextSlotNames = [
  [
    "root",
    "helpText__root"
  ],
  [
    "icon",
    "helpText__icon"
  ]
]
const helpTextSlotFns = /* @__PURE__ */ helpTextSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, helpTextDefaultVariants, getSlotCompoundVariant(helpTextCompoundVariants, slotName))])

const helpTextFn = memo((props = {}) => {
  return Object.fromEntries(helpTextSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const helpTextVariantKeys = [
  "variant"
]
const getVariantProps = (variants) => ({ ...helpTextDefaultVariants, ...compact(variants) })

export const helpText = /* @__PURE__ */ Object.assign(helpTextFn, {
  __recipe__: false,
  __name__: 'helpText',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: helpTextVariantKeys,
  variantMap: {
  "variant": [
    "link",
    "info",
    "error",
    "warning",
    "success"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, helpTextVariantKeys)
  },
  getVariantProps
})